import React from "react";
import Accordion from "react-bootstrap/Accordion";
import AddressField from "../../../../componennts/v3/address_field";
import Info_Component from "../components/info";

function Address_Section(props) {

    let addressData = props.data;

    return <div id={'address_section'} className={'p-1'}>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <Info_Component
                    text={'"+" - додавання рядку; "-" - видалення рядку'}
                />

                {
                    addressData.length <= 0 && <b>Не виявлено</b>
                }

                <button onClick={props.handleInsertData} className={'btn btn-secondary'}>
                    +
                </button>
            </div>
            <div id="list-address">
                {
                    addressData.map((address, i) => <div key={i}
                                                         className="d-flex justify-content-between align-items-center">

                        <small className={'text-secondary pt-2 opacity-25'}>#{i+1}</small>

                        <AddressField
                            id={i}
                            value={address}
                            onChange={props.handleChangeData}
                            add={props.handleInsertData}
                            placeholder={'Місто, Вулиця'}
                        />

                        <button onClick={() => props.handleRemoveData(i)}
                                className={'btn btn-outline-danger'}>
                            -
                        </button>

                    </div>)
                }

            </div>

        {/*<Accordion*/}
        {/*    defaultActiveKey="0"*/}
        {/*    flush className={'mt-5'}*/}
        {/*>*/}
        {/*    <Accordion.Item eventKey="0" className={''}>*/}
        {/*        <Accordion.Header>*/}
        {/*            <h5 className={'lead'}>Address</h5>*/}
        {/*        </Accordion.Header>*/}
        {/*        <Accordion.Body>*/}

        {/*            dynamic add address*/}

        {/*        </Accordion.Body>*/}
        {/*    </Accordion.Item>*/}
        {/*</Accordion>*/}

    </div>
}

export default Address_Section;
